import { render, staticRenderFns } from "./STTButton.vue?vue&type=template&id=3560890e"
import script from "./STTButton.vue?vue&type=script&lang=js"
export * from "./STTButton.vue?vue&type=script&lang=js"
import style0 from "./STTButton.vue?vue&type=style&index=0&id=3560890e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports